export default "__VITE_ASSET__CZ_pYRK1__"